// Token helpers for REST-based auth (tokens issued by the loginSam backend and
// stored in localStorage). Replaces Amplify's in-memory session for the admin.

export function getStoredToken(): string | null {
  return localStorage.getItem("token");
}

export function getStoredAccessToken(): string | null {
  return localStorage.getItem("accessToken");
}

export function getStoredRefreshToken(): string | null {
  return localStorage.getItem("refreshToken");
}

/** True for the error `refreshToken` throws when the server answered that the refresh token is no good (not a network or server failure). */
export const isRefreshRejected = (e: unknown): boolean => Boolean((e as { rejected?: boolean } | null)?.rejected);

export function decodeJwt(token: string): any | null {
  try {
    const part = token.split(".")[1];
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
    // handle UTF-8 payloads
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
}

export function getTokenClaims(): any | null {
  const t = getStoredToken();
  return t ? decodeJwt(t) : null;
}

export function isTokenExpired(token?: string | null, skewSeconds = 30): boolean {
  const t = token ?? getStoredToken();
  if (!t) return true;
  const claims = decodeJwt(t);
  if (!claims?.exp) return true;
  return Date.now() / 1000 >= claims.exp - skewSeconds;
}

export function storeTokens(t: {
  id_token?: string;
  access_token?: string;
  refresh_token?: string;
}): void {
  if (t.id_token) localStorage.setItem("token", t.id_token);
  if (t.access_token) localStorage.setItem("accessToken", t.access_token);
  if (t.refresh_token) localStorage.setItem("refreshToken", t.refresh_token);
}
